export default __webpack_public_path__ + "static/coming-soon-411251e7d19dc28940ba0f966e09020b.jpg";